module.exports = "<button\r\n    *ngFor=\"let item of buttonList; let i = index\"\r\n    class=\"tag-button\" (click)=\"toggleTag(item)\"\r\n    [ngClass]=\"{'tag-button-disabled': checkActiveTag(item),'tag-none':checkDisableTag(item)}\">\r\n    {{ item.title }}\r\n</button>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/o-button/button-tags/button-tags.component.html
// module id = ./src/app/commons/o-button/button-tags/button-tags.component.html
// module chunks = main